<section class="resume-section p-3 p-lg-5 d-flex flex-column" id="podcasts">
  <div class="my-auto">
    <h2 class="mb-5">Podcasts</h2>

    <input type="text" [(ngModel)]="filteredCategory" placeholder="Enter category">

    <br>
    <div class="shadow-sm p-3 mb-5 bg-white rounded">
      <table class="table table-responsive-sm">
        <thead>
        <tr>
          <th scope="col"><h4><span class="text-info" >Podcast</span></h4> </th>
          <th scope="col"><h4><span class="text-info" >Name</span></h4></th>
          <th scope="col"><h4><span class="text-info" >Category</span></h4></th>
          <th scope="col"><h4><span class="text-info" >Publisher</span></h4></th>
          <th scope="col"><h4><span class="text-info" >Date</span></h4></th>

        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let podcast of podcasts | filter:filteredCategory:'category'; let i = index"
         >

          <td>
          <div class="list-inline dev-icons">
            <a href="#podcastModal" (click)="openModal(podcast.podcastId)" data-toggle="modal" data-target="#podcastModal">
              <i class="fab fa-soundcloud"></i>
            </a>
          </div>
          </td>
          <td data-toggle="tooltip" data-placement="bottom" title="{{podcast.name}}">
            {{podcast.name | shorten:140}}
          </td>
          <td>
            {{podcast.category}}
          </td>
          <td>
            {{podcast.author}}
          </td>
          <td>
            {{podcast.date | date:'short' }}
          </td>
        </tr>
        </tbody>
      </table>


    </div>
    <!-- Modal -->
    <div class="modal fade" id="podcastModal" tabindex="-1" role="dialog" aria-labelledby="podcastModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-xs-12 col-sm-10 col-md-8 col-sm-offset-1 col-md-offset-2">

                  <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay"
                          [src]="this.choosenPodcast | sanitizer">

                  </iframe>

                </div>


              </div>


            </div>
          </div>
          <!--
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>

          </div>-->
        </div>
      </div>

    </div>
    <!-- Modal Ends -->

  </div>
</section>
